import { ActivateBlockActionType } from '../types.js'
import { getSlateTreeIndexInfo } from '../utils.js'
import { useCustomizer } from './use-customizer.hook.js'

export const useCustomizerBlockSettings = (): {
  blockId: string
  slateId: string
  action: ActivateBlockActionType
} => {
  const { state } = useCustomizer()
  const { id, action } = state.activeBlock || {}
  const { blockId, slateId } = getSlateTreeIndexInfo(id)

  return { blockId, slateId, action: action || null }
}
